import { css } from '@emotion/css';
import React from 'react';
import { FadeInImage, FadeInImageProps } from './FadeInImage';

type AspectRatioImageProps = FadeInImageProps;

export const AspectRatioImage: React.FC<AspectRatioImageProps> = ({
  width,
  height,
  style,
  ...rest
}) => {
  const aspectRatio = width && height ? width / height : undefined;
  return (
    <div
      className={css`
        position: relative;
        padding-top: ${aspectRatio ? `${100 / aspectRatio}%` : 'inherit'};
        img {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
      `}
      style={style}
    >
      <FadeInImage {...rest} />
    </div>
  );
};
